module.exports = __webpack_public_path__ + "img/img_manual1_3.685fc8c2.jpg";